export default __webpack_public_path__ + "static/media/landline.d3eeb440.svg";